<template>
  <div class="card search-result-pod has-h-100 has-p-3 ">
    <div class="row">
      <div class="col">
        <h2 class="has-text-gray-100 is-h5 has-font-size-medium has-mb-3 has-mt-0 has-text-primary">
          <a :href="link">{{ heading }}</a>
        </h2>
        <div class="search-debug">DEBUG | Category: {{ category }} | CategoryRank: {{ categoryRank }} | Importance: {{ importance }}</div>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col-12">
        <p class=" has-text-text has-mb-4 has-mt-xs-0 has-mt-sm-4 has-mt-md-0">
          {{ text.substring(0, 300) }}&hellip; <a :href="link" class="search-pod__link" title="Read more">&raquo;<span class="screen-reader-only">Read more on {{ heading }}</span></a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecommendedText",
  props:{
    heading: String,
    text: String,
    link: String,
    category: String,
    categoryRank: Number,
    importance: Number,  
  }
}
</script>